export enum NAMESPACE {
	PATHS = 'paths',
	LOC = 'loc'
}

export enum FORM_BUILDER_ELEMENTS {
	TAB_BOX = 'tabBox'
}

export enum FORM_TEMPLATE_STATUSES {
	IN_PROGRESS = 'IN_PROGRESS',
	PRODUCTION = 'PRODUCTION',
	ARCHIVED = 'ARCHIVED'
}

export enum FORM_TEMPLATE_TYPES {
	OUTBOUND = 'OUTBOUND',
	INBOUND = 'INBOUND'
}

export enum ITEM_PROPERTIES_RIGHT_SIDEBAR_TAB_KEYS {
	'TAB1' = '1',
	'TAB2' = '2',
	'TAB3' = '3'
}

// default values for layout dropping element
export enum DROPPING_ELEMENT {
	KEY = '__dropping-elem__',
	HEIGHT = 7,
	WIDTH = 3
}

export enum RADIO_BTN_GROUP_FIELD {
	FORM_TYPE = 'FORM_TYPE',
	TEXT_TYPE = 'TEXT_TYPE',
	POSITION = 'POSITION',
	SIZE = 'SIZE',
	TWO_SIZE = 'TWO_SIZE',
	TEXT_ALIGN = 'TEXT_ALIGN',
	GROUP_ALIGN = 'GROUP_ALIGN'
}

export enum FIELD_SIZE {
	S = 'S',
	M = 'M',
	L = 'L'
}

export enum ELEMENT_TYPES {
	INPUT = 'input',
	TEXT = 'text',
	DROPDOWN_BUTTON = 'dropdownButton',
	CHECK_BOX = 'checkBox',
	RADIO_BUTTON = 'radioButton',
	TEXT_AREA = 'textArea',
	HORIZONTAL_LINE = 'horizontalLine',
	DATE_PICKER = 'datePicker',
	CALENDAR = 'calendar',
	BUTTON = 'button',
	TABLE = 'table',
	TITLE = 'title',
	TAB_BOX = 'tabBox',
	TAB = 'tab',
	IMAGE = 'image',
	SELECT_FROM_TABLE = 'selectFromTable'
}

export enum OBJECTS {
	OBJECT_STATUS = 'objectStatus'
}

export enum ITEM_LABEL_POSITION {
	LEFT = 'LEFT',
	TOP = 'TOP'
}

export enum TEXT_TYPES {
	BOLD = 'BOLD',
	ITALIC = 'ITALIC',
	UNDERLINE = 'UNDERLINE'
}

export enum API_RESPONSES_TYPES {
	SUCCESS = 'SUCCESS'
}

export enum HEIGHT_OPERATIONS {
	SUBSTRACTION = 'SUBSTRACTION',
	CHANGE = 'CHANGE'
}

export enum FORM {
	LOGIN = 'LOGIN',
	FORM_GENERAL_SETTINGS = 'FORM_GENERAL_SETTINGS',
	PROCEDURES_SETTINGS = 'PROCEDURES_SETTINGS',
	FORM_DOCS_PAGE_FILTER = 'FORM_DOCS_PAGE_FILTER',
	DOCS_PAGE_FILTER = 'DOCS_PAGE_FILTER',
	TEMPLATES_PAGE_FILTER = 'TEMPLATES_PAGE_FILTER',
	GENERALE_TEMPLATE_ATTRIBUTES = 'GENERALE_TEMPLATE_ATTRIBUTES',
	FORM_TEMPLATE = 'FORM_TEMPLATE',
	INPUT_ELEMENT_FORM = 'INPUT_ELEMENT_FORM',
	DROPDOWNBUTTON_ELEMENT_FORM = 'DROPDOWNBUTTON_ELEMENT_FORM',
	BUTTON_ELEMENT_FORM = 'BUTTON_ELEMENT_FORM',
	PARAGRAPH_ELEMENT_FORM = 'PARAGRAPH_ELEMENT_FORM',
	TITLE_ELEMENT_FORM = 'TITLE_ELEMENT_FORM',
	TEXT_AREA_ELEMENT_FORM = 'TEXT_AREA_ELEMENT_FORM',
	TEMPLATE_GENERAL_SETTINGS = 'TEMPLATE_GENERAL_SETTINGS',
	HORIZONTAL_LINE_ELEMENT_FORM = 'HORIZONTAL_LINE_ELEMENT_FORM',
	DATE_ELEMENT_FORM = 'DATE_ELEMENT_FORM',
	CHECKBOX_ELEMENT_FORM = 'CHECKBOX_ELEMENT_FORM',
	RADIO_BUTTON_ELEMENT_FORM = 'RADIO_BUTTON_ELEMENT_FORM',
	IMAGE_ELEMENT_FORM = 'IMAGE_ELEMENT_FORM',
	TABLE_ELEMENT_FORM = 'TABLE_ELEMENT_FORM',
	TAB_BOX_ELEMENT_FORM = 'TAB_BOX_ELEMENT_FORM',
	SELECT_FROM_TABLE_ELEMENT_FORM = 'SELECT_FROM_TABLE_ELEMENT_FORM',
	DUPLICATE_TEMPLATE = 'DUPLICATE_TEMPLATE',
	SQL_EDITOR_FORM = 'SQL_EDITOR_FORM',
	VALIDATION_FORM = 'VALIDATION_FORM',
	ELEMENT_CSS_FORM = 'ELEMENT_CSS_FORM',
	DOCUMENT_FORM = 'DOCUMENT_FORM'
}

export enum FORM_KEYS {
	OPTIONS = 'options'
}

export enum NOTIFICATION_TYPE {
	MODAL = 'MODAL',
	NOTIFICATION = 'NOTIFICATION'
}

export enum MSG_TYPE {
	INFO = 'INFO',
	ERROR = 'ERROR',
	WARNING = 'WARNING',
	SUCCESS = 'SUCCESS'
}

export enum FORM_DOC_ORDER {
	QUEUE = 'queue',
	NAME = 'name',
	CREATED_AT = 'createdAt',
	UPDATED_AT = 'updatedAt'
}

export enum TEMPLATE_ORDER {
	NAME = 'name',
	CREATED_AT = 'createdAt',
	UPDATED_AT = 'updatedAt'
}

export enum FORM_DOC_STATUS {
	PRODUCTION = 'PRODUCTION',
	ARCHIVED = 'ARCHIVED',
	IN_PROGRESS = 'IN_PROGRESS'
}

export enum PAGE {
	FORMS = 'Forms',
	TEMPLATES = 'Templates',
	USERS = 'Users',
	FORM_BUILDER = 'form-builder',
	SETTINGS = 'settings',
	TEMPLATE_SETTINGS = 'template-settings',
	TEMPLATE_BUILDER = 'template-builder',
	FORM_PREVIEW = 'form-preview',
	TEMPLATE_PREVIEW = 'template-preview'
}

export enum BASE_MENU_TAB_PATHS {
	FORMS = 'forms',
	TEMPLATES = 'templates',
	USERS = 'users'
}

export enum PERMISSION {
	SUPER_ADMIN = 'SUPER_ADMIN',
	ADMIN = 'ADMIN'
}

export const PAGINATION = {
	defaultPageSize: 25,
	pageSizeOptions: ['25', '50', '100'],
	limit: 25 // 25 | 50 | 100
}

export const PAGINATION_USER_LIMIT = 100

export enum MAIN_LAYOUT {
	Z_INDEX = 1
}

export const NUMBER_OF_ROWS = {
	LABEL_POSITION: 3,
	HINT_POSITION: 3,
	S_SIZE: 3,
	M_SIZE: 4,
	L_SIZE: 5,
	BUTTON_S_SIZE: 4,
	BUTTON_M_SIZE: 5,
	HORIZONTAL_LINE: 2,
	SELECT_FROM_TABLE: 19
}

export enum ELEMENT_ATTRIBUTES {
	SIZE = 'size',
	COL = 'col',
	ROW = 'row',
	LABEL_POSITION = 'labelPosition',
	LABEL = 'label',
	LABEL_COLOR = 'labelColor',
	LABEL_TEXT_TYPE = 'labelTextType',
	PREFIX_ICON = 'prefix',
	SUFFIX_ICON = 'suffix',
	ACTION = 'action',
	TABLE_COLUMN = 'tableColumn',
	PLACEHOLDER = 'placeholder',
	PLACEHOLDER_COLOR = 'placeholderColor',
	PLACEHOLDER_TEXT_TYPE = 'placeholderTextType',
	HINT = 'hint',
	HINT_COLOR = 'hintColor',
	HINT_TEXT_TYPE = 'hintTextType',
	REQUIRED = 'required',
	READ_ONLY = 'readOnly',
	TEXT_ALIGNMENT = 'textAlignment',
	FONT_SIZE = 'fontSize',
	PARAGRAPH = 'paragraph',
	TITLE = 'title',
	TIME = 'time',
	DATE = 'date',
	DISPLAYED_OPTIONS = 'displayedOptions',
	RADIO_GROUP_ALIGN = 'radioGroupAlign',
	IMAGE = 'image',
	OPERATOR_EDITABLE = 'operatorEditable',
	ROWS = 'rows',
	COLUMNS = 'columns',
	ALLOW_SWITCH_TABS = 'switchTabs',
	SQL = 'sql',
	SQL_VARIABLES = 'sqlVariables',
	CONDITIONS = 'conditions',
	VISIBILITY = 'visibility',
	VALIDATION = 'validation',
	ADD_STORED_PROCEDURE = 'addStoredProcedure',
	HTML_VALIDATION = 'htmlValidation',
	LINKED_FIELDS = 'linkedFields',
	IS_AUTOCOMPLETE = 'isAutocomplete',
	PROCEDURE_AUTOCOMPLETE_DROPDOWN = 'procedureAutocompleteDropdown',
	PROCEDURE_AUTOCOMPLETE_CONFIRM = 'procedureAutocompleteConfirm',
	FIELDS_AUTOCOMPLETE_DROPDOWN = 'fieldsAutocompleteDropdown',
	FIELDS_AUTOCOMPLETE_CONFIRM = 'fieldsAutocompleteConfirm',
	AUTOCOMPLETE_CHOOSE_ONLY_FROM_OPTIONS = 'chooseOnlyFromOptions',
	MAX_SELECTED_ROWS = 'maxSelectedRows'
}

export enum TABLE_PROCEDURE_ATTRIBUTES {
	PROCEDURE = 'procedure',
	ALLOW_PROCEDURE = 'allowProcedure',
	FIELDS_LIST = 'fieldsList'
}

export enum FORM_ATTRIBUTES {
	BACKGROUND = 'background'
}

export enum TEXT_ALIGNMENT {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right'
}

export enum RADIO_BUTTON_GROUP_ALIGNMENT {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal'
}

export enum TEMPLATE_BUILDER_HEADER_TABS {
	BUILDER = 'template-builder',
	PREVIEW = 'template-preview',
	SETTINGS = 'template-settings'
}

export enum FORM_BUILDER_HEADER_TABS {
	BUILDER = 'form-builder',
	PREVIEW = 'form-preview',
	SETTINGS = 'settings'
}

export enum ROLES {
	ADMINISTRATOR = 'ADMINISTRATOR'
}

export enum RENDER_LABEL_TYPE {
	PARAGRAPH = 'paragraph',
	INPUT = 'input',
	DROPDOWN_BUTTON = 'dropdownButton',
	CHECK_BOX = 'checkBox',
	RADIO_BUTTON = 'radioButton',
	TEXT_AREA = 'textArea',
	HORIZONTAL_LINE = 'horizontalLine',
	DATE_PICKER = 'datePicker',
	BUTTON = 'button',
	TABLE = 'table',
	TITLE = 'title',
	TAB_BOX = 'tabBox',
	SELECT_FROM_TABLE = 'selectFromTable'
}

export enum CONDITIONS_TYPES {
	EQUALS = 'EQUALS',
	NOT_EQUALS = 'NOT_EQUALS',
	STARTS_WITH = 'STARTS_WITH',
	END_WITH = 'END_WITH',
	IN = 'IN',
	NOT_IN = 'NOT_IN',
	LESS_THAN = 'LESS_THAN',
	LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
	GREATER_THAN = 'GREATER_THAN',
	GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
	IS_EMPTY = 'IS_EMPTY',
	IS_NOT_EMPTY = 'IS_NOT_EMPTY'
}

export enum VALIDATIONS_TYPES {
	EMAIL = 'email',
	INTEGER = 'integer',
	DECIMAL_NUMBER = 'decimal number',
	TELEPHONE_NUMBER = 'telephone number',
	WEBSITE = 'website'
}

export enum LOGICAL_OPERATORS {
	AND = 'AND',
	OR = 'OR'
}

export enum VALIDATION_FORM_FIELD_ARRAYS {
	REQUIRED_AND_OPTIONS = 'requiredANDOptions',
	REQUIRED_OR_OPTIONS = 'requiredOROptions',
	VISIBILITY_AND_OPTIONS = 'visibilityANDOptions',
	VISIBILITY_OR_OPTIONS = 'visibilityOROptions'
}

export const VALIDATION_MODAL_NUMBER_OF_ROWS = 5

export enum BUTTON_ACTIONS {
	SUBMIT_FORM = 'submit form',
	OPEN_NEXT_ACTIVITY = 'open next activity',
	CALL_NUMBER = 'call a phone number',
	SEND_EMAIL = 'send email',
	SEND_SMS = 'send sms',
	CALL_PROCEDURE = 'call procedure',
	GO_TO_NEXT_TAB = 'go to next tab',
	CALL_URL = 'call url'
}

export const BUTTON_ACTION_OPTIONS = () => [
	{
		label: 'Submit form',
		value: BUTTON_ACTIONS.SUBMIT_FORM
	},
	{
		label: 'Submit form - open next activity',
		value: BUTTON_ACTIONS.OPEN_NEXT_ACTIVITY
	},
	{
		label: 'Call a phone number',
		value: BUTTON_ACTIONS.CALL_NUMBER
	},
	{
		label: 'Send email',
		value: BUTTON_ACTIONS.SEND_EMAIL
	},
	{
		label: 'Send sms',
		value: BUTTON_ACTIONS.SEND_SMS
	},
	{
		label: 'Call procedure',
		value: BUTTON_ACTIONS.CALL_PROCEDURE
	},
	{
		label: 'Go to next tab',
		value: BUTTON_ACTIONS.GO_TO_NEXT_TAB
	},
	{
		label: 'Call url',
		value: BUTTON_ACTIONS.CALL_URL
	}
]

export enum BUTTON_ACTIONS_ATTRIBUTES {
	FORM_ITEM_ID = 'formItemId',
	EMAIL_SUBJECT = 'emailSubject',
	EMAIL_BODY = 'emailBody',
	SMS_BODY = 'smsBody',
	EMAIL_CONFIG = 'emailConfig',
	URL = 'url',
	URL_TYPE = 'urlType',
	QUERY_ATTRIBUTES = 'queryAttributes',
	OPEN_MODAL = 'openModal',
	OPEN_NEW_TAB = 'openNewTab',
	MODAL_SIZE = 'modalSize',
	CLOSE_ICON_MODAL = 'closeIconModal',
	PROCEDURE = 'procedure',
	FIELDS_LIST = 'fieldsList',
	TAB = 'tabKey'
}

export const ELEMENTS_WITH_VISIBILITY: string[] = [
	ELEMENT_TYPES.TEXT,
	ELEMENT_TYPES.BUTTON,
	ELEMENT_TYPES.TABLE,
	ELEMENT_TYPES.TITLE,
	ELEMENT_TYPES.IMAGE,
	ELEMENT_TYPES.SELECT_FROM_TABLE
]

export const ELEMENTS_WITH_VISIBILITY_AND_VALIDATION: string[] = [
	ELEMENT_TYPES.INPUT,
	ELEMENT_TYPES.DROPDOWN_BUTTON,
	ELEMENT_TYPES.CHECK_BOX,
	ELEMENT_TYPES.RADIO_BUTTON,
	ELEMENT_TYPES.TEXT_AREA,
	ELEMENT_TYPES.DATE_PICKER
]

export const ICONS: string[] = [
	'SaveOutlined',
	'ArrowDownOutlined',
	'ArrowUpOutlined',
	'ArrowLeftOutlined',
	'ArrowRightOutlined',
	'DownloadOutlined',
	'QuestionCircleOutlined',
	'QuestionOutlined',
	'PlusOutlined',
	'CloseOutlined',
	'CloseCircleOutlined',
	'DeleteOutlined',
	'CopyOutlined',
	'WechatOutlined',
	'MessageOutlined',
	'TwitterOutlined',
	'FacebookOutlined',
	'InstagramOutlined',
	'LinkedinOutlined',
	'DeliveredProcedureOutlined',
	'ExportOutlined',
	'MailOutlined',
	'CalendarOutlined',
	'EnvironmentOutlined',
	'ImportOutlined',
	'InboxOutlined',
	'PhoneOutlined',
	'PrinterOutlined',
	'PushpinOutlined',
	'ReloadOutlined',
	'SearchOutlined',
	'SendOutlined',
	'ShoppingCartOutlined',
	'ScanOutlined',
	'ShoppingOutlined',
	'SyncOutlined',
	'ToolOutlined',
	'ExportOutlined',
	'UploadOutlined',
	'WhatsAppOutlined',
	'UserAddOutlined',
	'UserDeleteOutlined',
	'UserOutlined',
	'UserSwitchOutlined',
	'UsergroupAddOutlined',
	'UsergroupDeleteOutlined',
	'ThunderboltOutlined',
	'SettingOutlined',
	'ShareAltOutlined',
	'TableOutlined',
	'LockOutlined',
	'UnlockOutlined',
	'LikeOutlined',
	'DislikeOutlined',
	'CloudDownloadOutlined',
	'DatabaseOutlined',
	'DeleteRowOutlined',
	'DeleteColumnOutlined',
	'LineChartOutlined'
]

export enum KEYS_SHORTCUTS {
	CTRL_D = 'ctrl+d',
	CTRL_C = 'ctrl+c'
}

export enum STATUS_OBJECT_DEFAULT_VALUES {
	DATE_LABEL = 'Dátum budúceho kontaktu',
	DROPDOWN_LABEL = 'Finálny status',
	BUTTON_LABEL = 'Uložiť'
}

export enum LANGUAGE {
	EN = 'en'
}

export const REFRESH_PAGE_INTERVAL = 1000 * 60 * 60 * 4 // 4 hours

export const SQL_EDITOR_VARIABLE_ERROR = 'Error - variables in query'

export const DEFAULT_OBJECT_STATUS_WIDTH = 5

export const DEFAULT_BUTTON_HEIGHT = 5

export const BACK_DATA_QUERY = 'backData'

export const ANT_MESSAGE_KEY = '1'

export const DEFAULT_TAB_BOX_HEIGHT = 150

export const TAB_BOX_TABS_NAV_WRAP_HEIGHT = 32

export const PROTECTION_INTERVAL_FOR_FILTER = 300

export const PROTECTION_INTERVAL_FOR_SAVING_ELEMENT = 900

// layout row height in pixels
export const LAYOUT_ROW_HEIGHT = 8

export const DEFAULT_LABEL_COLOR = '#000'

export const DEFAULT_HINT_COLOR = '#000'

export const DEFAULT_PLACEHOLDER_COLOR = '#000'

export const EDITING_TIME_MINUTES_LIMIT = 10

export const DEFAULT_NUMBERS_OF_COLS = 12

export const DEFAULT_DATE_INPUT_FORMAT = 'D.M.YYYY'

export const DEFAULT_DATE_INIT_FORMAT = 'YYYY-MM-DD'

export const DEFAULT_TIME_FORMAT = 'HH:mm'

export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY'

export const DEFAULT_DATE_WITH_TIME_FORMAT = 'DD.MM.YYYY HH:mm'

export const DEFAULT_DATE_WITH_TIME_FORMAT_DD_MM_YYYY = 'DD.MM.YYYY'

export const DEFAULT_DATE_WITH_TIME_FORMAT_HH_MM = 'HH:mm'

export const INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT'

export const DEFAULT_DISPLAYED_OPTIONS = 6

export const DEFAULT_NUMBER_OF_TEMPLATES = 8

export const DEFAULT_TABLE_COLUMNS = 3

export const DEFAULT_TABLE_ROWS = 3

export const DEFAULT_TITLE_SIZE = 24

export const DEFAULT_ERROR_MESSAGE = 'ERROR'
